import { useMutation, useQueryClient } from 'react-query';
import { authFetch } from '../../../CommonUtils/authFetch';
import { httpBodyOptions } from '../../../CommonUtils/httpBodyOptions';
import { queryKeys } from './queryKeys';

interface FetcherParams {
  clientId: string;
  incomeId: string;
}

const deleteIncome = ({ clientId, incomeId }: FetcherParams) => {
  return authFetch('/Consumer/IncomeUpdate/Delete', {
    method: 'POST',
    ...httpBodyOptions({ clientId, id: incomeId }),
  });
};

interface Params {
  clientId: string;
}

export const useDeleteIncomeMutation = ({ clientId }: Params) => {
  const queryClient = useQueryClient();

  return useMutation(deleteIncome, {
    async onSuccess() {
      await queryClient.refetchQueries(queryKeys.income(clientId));
    },
  });
};
